import Controller from '@ember/controller';
import { action, computed, get, set, setProperties } from '@ember/object';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';

export default Controller.extend({
  cachedDataset: service(),
  router: service(),
  store: service(),

  rolesSortBy: ['name'],
  sortedRoles: computed('model.roles', 'rolesSortBy', function () {
    let roles = get(this, 'model.roles');
    let rolesSortBy = get(this, 'rolesSortBy');
    return sortByProperties(roles, rolesSortBy);
  }),

  roleOptions: computed('sortedRoles', function () {
    return this.sortedRoles.map((r) => r.name);
  }),

  saving: false,
  showValidationErrors: false,

  reset() {
    setProperties(this, {
      saving: false,
      showValidationErrors: false,
    });
  },

  save: action(function () {
    let changeset = get(this, 'model.changeset');
    changeset.validate().then(() => {
      if (get(changeset, 'isValid')) {
        setProperties(this, {
          saving: true,
          showValidationErrors: false,
        });

        changeset.save().then(() => {
          this.cachedDataset.forModel('admin/user').update(this.model.model);
          this.router.transitionTo(
            'admin.users.show',
            get(this, 'model.model.id'),
          );
        });
      } else {
        set(this, 'showValidationErrors', true);
      }
    });
  }),
});
